import { baseApi } from './baseApi';

/**
 * Auth API endpoints
 * Handles login, logout, and session renewal
 */
export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // POST /auth/login - User login
    login: builder.mutation({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
      // On successful login, store token and update auth state
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // Store token in localStorage
          localStorage.setItem('token', data.token);
        } catch (error) {
          // Error handling is done by the component
        }
      },
      invalidatesTags: ['Auth'],
    }),

    // POST /auth/logout - User logout
    logout: builder.mutation({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
      // On logout, clear token
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        // Clear token immediately, don't wait for response
        localStorage.removeItem('token');
        try {
          await queryFulfilled;
        } catch (error) {
          // Even if logout API fails, we've already cleared the token
          console.warn('Logout API call failed, but local session cleared');
        }
      },
      invalidatesTags: ['Auth'],
    }),

    // POST /auth/renew - Renew session token
    renewSession: builder.mutation({
      query: () => ({
        url: '/auth/renew',
        method: 'POST',
      }),
      // On successful renewal, update token
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          localStorage.setItem('token', data.token);
        } catch (error) {
          // On renewal failure, clear token
          localStorage.removeItem('token');
        }
      },
      invalidatesTags: ['Auth'],
    }),
  }),
});

// Export hooks for use in components
export const {
  useLoginMutation,
  useLogoutMutation,
  useRenewSessionMutation,
} = authApi;

